export enum OptimizationTarget {
  FOP = "FOP",
  CLTV = "cLTV",
  CLTP = "cLTP",
  CP = "CP",
  Custom = "custom",
}

export enum BiddingStrategy {
  Value = "value",
  LowestCPA = "lowest-cpa",
}

export const PERIODS = [30, 90, 180, 365] as const;
export const PERIODS_CP = [7, 28] as const;
export const PERIODS_ALL = [...PERIODS, ...PERIODS_CP] as const;
export type OptimizationPeriod = (typeof PERIODS_ALL)[number];

export interface OptimizationRule {
  id: number;
  "workspace-id": number;
  "owner-id": number;
  name: string;
  description: string;
  target: OptimizationTarget;
  period: OptimizationPeriod;
  "bidding-strategy": BiddingStrategy;
  "custom-value-cutoff": number | null;
  "custom-cpa-cutoff": number | null;
  "custom-fop-weight": number | null;
  "custom-cltv-weight": number | null;
  "custom-cltp-weight": number | null;
  "max-value": number | null;
  "min-value-%ile": number | null;
  "max-value-%ile": number | null;
  "avg-order-value": number | null;
  "created-at": string;
  "updated-at": string;
}
